import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectCachedClientCompanyNames = (state: StoreSchema) => {
    return state.client.cachedClient.companyNames
}
